import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment-timezone';
import { InsertChartOutlined, ThreeSixty } from '@material-ui/icons';
import { Card, Divider, Typography, Button, CardContent, Slider, Box, CircularProgress } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import baseStyle from '../../../styles/dashboard';
import { BarChart as BarIcon, Close } from '@material-ui/icons';
import { PieChartRounded } from '@material-ui/icons';
import { Timeline } from '@material-ui/icons';
import { ResponsiveBar, Bar } from '@nivo/bar';
import Carousel from 'nuka-carousel';
import { ResponsiveLine, Line } from '@nivo/line';
import { Paper, Toolbar, Tooltip } from '@material-ui/core';
import { IconButton } from '@material-ui/core';
import DataTable from '../../components/Shared/DataTable';
import PercentToTargetLine from '../../components/Charts/PercentToTargetLine';
import { FormattedMessage } from 'react-intl';
import ProgressBar from "@ramonak/react-progress-bar";
import { Dialog, DialogActions, DialogContent, DialogTitle } from '@material-ui/core';
import { getProgress, getSevenDayTime, getDashboardChartData, getStudent, getAIAudioFile, getStudentProfile, getReviewData, getReadingTime, patchStudentProfile, checkStudentProfile, createStudentProfile, getBooksForStudent, getWPMBooks } from '../../../redux/actions'
import { Link } from 'react-router-dom';
import DashboardDataContainer from '../../components/Shared/Dashboard/DashboardDataContainer';

import "react-circular-progressbar/dist/styles.css";
import PhonemesReview from '../../components/Shared/ReviewModal';
import LastSevenDay from '../../components/Shared/LastSevenDay';
import ReviewTable from '../../components/Shared/Dashboard/ReviewTable';


const minutes = (value) => {
    let val = (Math.round(value) / 60.0).toFixed(0);
    let type = "Minutes";
    if (val > 60) {
        val = (value / 60.0).toFixed(1)
        type = "Hours";
    }
    return `${val} ${type}`
};

const minutesAxis = (value) => {
    let val = (Math.round(value) / 60.0).toFixed(0);
    let type = "Minutes";
    if (val > 60) {
        val = (value / 60.0).toFixed(1)
        type = "Hours";
    }
    return `${val}`
}

const percentage = (value) => {
    return `${value}%`;
}

const dateFormat = (value) => {
    return `${moment.utc(value).toDate()}`;
}

const CollisionLink = (url) => React.forwardRef((props, ref) => (
    <Link innerRef={ref} to={url} {...props} />
));

const selectOptions = [30,90,365,"All Time"]

class BuddyBooksData extends Component {

    state = {
        progress: {},
        timeChart: [],
        phonemes: [],
        phonemesSpecific: [],
        accuracy: [],
        fluency: [],
        time: 7,
        clicked: false,
        skill: {},
        reviewData: [],
        readingTime: [],
        readingTimeValue: 10,
        downloadComplete: false,
        bookListWPM: [],
        accuracyOption: 30,
        fluencyOption: 30,
        selectedReviewData: {},
        reviewDataLoaded: false
    };

    componentDidMount() {
        const endDate = moment().add(1, 'day').format('YYYY-MM-DD');
        const startDate = moment().subtract(30, 'days').format('YYYY-MM-DD');
        
        this.props.getStudent(this.props.id);
        getProgress(this.props.id).then(data => {
            if (data) {
                this.setState({ progress: data })
            }
            this.setState({ progressLoaded: true })
        });
        getSevenDayTime(this.props.id).then(data => {
            if (data) {
                data = data.reverse();
                this.setState({ timeChart: data });
            }
        });


        getDashboardChartData(this.props.id, startDate, endDate).then(data => {
            if (data) {
                console.log('getDashboardChartData dashboard response', data);
                this.setState({ 
                    accuracy: data.accuracy || [], 
                    accuracyLoaded: true,
                    fluency: data.fluency || [],
                    fluencyLoaded: true,
                    skipRate: data.skipRate || [],
                    skipRateLoaded: true,
                    reviewModes: data.reviewModes || []
                });
            } else {
                this.setState({ 
                    accuracyLoaded: true,
                    fluencyLoaded: true,
                    skipRateLoaded: true
                });
            }
        }).catch(error => {
            console.error('Error fetching dashboard chart data:', error);
            this.setState({
                accuracyLoaded: true,
                fluencyLoaded: true,
                skipRateLoaded: true
            });
        });


        getReviewData(this.props.id).then(data => {
            if (data) {
                console.log('getReview dashboard response', data);
                this.setState({ 
                    reviewData: data, 
                    reviewDataLoaded: true 
                });
            } else {
                this.setState({ reviewDataLoaded: true });
            }
        })
        getReadingTime(this.props.id).then(data => {
            this.setState({
                readingTime: data,
                downloadComplete: true
            });
        })
        this.props.getStudentProfile(this.props.id);
        checkStudentProfile(this.props.id).catch((e) => {
            this.props.createStudentProfile({ studentId: this.props.id, readingTime: 10 });
        })
        this.props.getBooksForStudent(this.props.id);
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.studentProfile != this.props.studentProfile) {
            this.setState({
                readingTimeValue: this.props.studentProfile.readingTime
            });
        }

    }


    showReviewModal = (data, reviewMode = false) => {
        
        // Parse the analysis JSON strings
        let firstAnalysisObj = {};
        let secondAnalysisObj = {};
        
        try {
            // Check if we have firstReview or if it's a transformed record with firstReview already inside
            if (data.firstReview && data.firstReview.analysis) {
                if (typeof data.firstReview.analysis === 'string') {
                    // First trim any leading/trailing spaces
                    const cleanedAnalysis = data.firstReview.analysis.trim();
                    // Parse the JSON string
                    firstAnalysisObj = JSON.parse(cleanedAnalysis);
                } else {
                    // If it's already an object, use it directly
                    firstAnalysisObj = data.firstReview.analysis;
                }
            }
            
            if (data.secondReview && data.secondReview.analysis) {
                if (typeof data.secondReview.analysis === 'string') {
                    // First trim any leading/trailing spaces
                    const cleanedAnalysis = data.secondReview.analysis.trim();
                    // Parse the JSON string
                    secondAnalysisObj = JSON.parse(cleanedAnalysis);
                } else {
                    // If it's already an object, use it directly
                    secondAnalysisObj = data.secondReview.analysis;
                }
            }
        } catch (error) {
            console.error("Error parsing analysis JSON:", error);
        }
        
        // Process the pronunciation Words array to match ReviewText expectations
        const extractWordsData = (analysisObj) => {
            if (!analysisObj || !analysisObj.pronunciation || !analysisObj.pronunciation.Words) return [];
            
            return analysisObj.pronunciation.Words.map(word => {
                // Extract the main AccuracyScore - look in different possible locations
                let accuracyScore = 0;
                if (word.PronunciationAssessment && word.PronunciationAssessment.AccuracyScore) {
                    accuracyScore = word.PronunciationAssessment.AccuracyScore;
                } else if (word.pronunciationAssessment && word.pronunciationAssessment.AccuracyScore) {
                    accuracyScore = word.pronunciationAssessment.AccuracyScore;
                } else if (word.AccuracyScore) {
                    accuracyScore = word.AccuracyScore;
                } else if (word.accuracyScore) {
                    accuracyScore = word.accuracyScore;
                }
                
                // Extract ErrorType - look in different possible locations
                let errorType = "None";
                if (word.PronunciationAssessment && word.PronunciationAssessment.ErrorType) {
                    errorType = word.PronunciationAssessment.ErrorType;
                } else if (word.pronunciationAssessment && word.pronunciationAssessment.ErrorType) {
                    errorType = word.pronunciationAssessment.ErrorType;
                } else if (word.ErrorType) {
                    errorType = word.ErrorType;
                } else if (word.errorType) {
                    errorType = word.errorType;
                }
                
                // Process phonemes array with correct property casing
                const phonemes = [];
                if (word.Phonemes && word.Phonemes.length) {
                    word.Phonemes.forEach(phoneme => {
                        let phonemeAccuracy = 0;
                        if (phoneme.PronunciationAssessment && phoneme.PronunciationAssessment.AccuracyScore) {
                            phonemeAccuracy = phoneme.PronunciationAssessment.AccuracyScore;
                        } else if (phoneme.pronunciationAssessment && phoneme.pronunciationAssessment.AccuracyScore) {
                            phonemeAccuracy = phoneme.pronunciationAssessment.AccuracyScore;
                        } else if (phoneme.AccuracyScore) {
                            phonemeAccuracy = phoneme.AccuracyScore;
                        } else if (phoneme.accuracyScore) {
                            phonemeAccuracy = phoneme.accuracyScore;
                        }
                        
                        phonemes.push({
                            Phoneme: phoneme.Phoneme || phoneme.phoneme || "",
                            AccuracyScore: phonemeAccuracy
                        });
                    });
                } else if (word.phonemes && word.phonemes.length) {
                    word.phonemes.forEach(phoneme => {
                        let phonemeAccuracy = 0;
                        if (phoneme.PronunciationAssessment && phoneme.PronunciationAssessment.AccuracyScore) {
                            phonemeAccuracy = phoneme.PronunciationAssessment.AccuracyScore;
                        } else if (phoneme.pronunciationAssessment && phoneme.pronunciationAssessment.AccuracyScore) {
                            phonemeAccuracy = phoneme.pronunciationAssessment.AccuracyScore;
                        } else if (phoneme.AccuracyScore) {
                            phonemeAccuracy = phoneme.AccuracyScore;
                        } else if (phoneme.accuracyScore) {
                            phonemeAccuracy = phoneme.accuracyScore;
                        }
                        
                        phonemes.push({
                            Phoneme: phoneme.Phoneme || phoneme.phoneme || "",
                            AccuracyScore: phonemeAccuracy
                        });
                    });
                }
                
                // Return properly formatted word object with uppercase first letter properties
                return {
                    Word: word.Word || word.word || "",
                    AccuracyScore: accuracyScore,
                    Offset: word.Offset || word.offset || 0,
                    Duration: word.Duration || word.duration || 0,
                    ErrorType: errorType,
                    Phonemes: phonemes
                };
            });
        };
        
        // Extract score from firstAnalysisObj
        const getPronScore = (analysisObj) => {
            if (analysisObj.pronunciation && analysisObj.pronunciation.PronunciationAssessment && analysisObj.pronunciation.PronunciationAssessment.PronScore) {
                return analysisObj.pronunciation.PronunciationAssessment.PronScore;
            }
            if (analysisObj.pronunciation && analysisObj.pronunciation.pronunciationAssessment && analysisObj.pronunciation.pronunciationAssessment.PronScore) {
                return analysisObj.pronunciation.pronunciationAssessment.PronScore;
            }
            if (analysisObj.PronScore) {
                return analysisObj.PronScore;
            }
            if (analysisObj.pronScore) {
                return analysisObj.pronScore;
            }
            return analysisObj.accuracyScore || 0;
        };
        
        const getAccuracyScore = (analysisObj) => {
            if (analysisObj.pronunciation && analysisObj.pronunciation.PronunciationAssessment && analysisObj.pronunciation.PronunciationAssessment.AccuracyScore) {
                return analysisObj.pronunciation.PronunciationAssessment.AccuracyScore;
            }
            if (analysisObj.pronunciation && analysisObj.pronunciation.pronunciationAssessment && analysisObj.pronunciation.pronunciationAssessment.AccuracyScore) {
                return analysisObj.pronunciation.pronunciationAssessment.AccuracyScore;
            }
            if (analysisObj.AccuracyScore) {
                return analysisObj.AccuracyScore;
            }
            return analysisObj.accuracyScore || 0;
        };
        
        const getFluencyScore = (analysisObj) => {
            if (analysisObj.pronunciation && analysisObj.pronunciation.PronunciationAssessment && analysisObj.pronunciation.PronunciationAssessment.FluencyScore) {
                return analysisObj.pronunciation.PronunciationAssessment.FluencyScore;
            }
            if (analysisObj.pronunciation && analysisObj.pronunciation.pronunciationAssessment && analysisObj.pronunciation.pronunciationAssessment.FluencyScore) {
                return analysisObj.pronunciation.pronunciationAssessment.FluencyScore;
            }
            if (analysisObj.FluencyScore) {
                return analysisObj.FluencyScore;
            }
            return analysisObj.fluencyScore || 0;
        };
        
        const getCompletenessScore = (analysisObj) => {
            if (analysisObj.pronunciation && analysisObj.pronunciation.PronunciationAssessment && analysisObj.pronunciation.PronunciationAssessment.CompletenessScore) {
                return analysisObj.pronunciation.PronunciationAssessment.CompletenessScore;
            }
            if (analysisObj.pronunciation && analysisObj.pronunciation.pronunciationAssessment && analysisObj.pronunciation.pronunciationAssessment.CompletenessScore) {
                return analysisObj.pronunciation.pronunciationAssessment.CompletenessScore;
            }
            if (analysisObj.CompletenessScore) {
                return analysisObj.CompletenessScore;
            }
            return analysisObj.completenessScore || 0;
        };
        
        const getProsodyScore = (analysisObj) => {
            if (analysisObj.pronunciation && analysisObj.pronunciation.PronunciationAssessment && analysisObj.pronunciation.PronunciationAssessment.ProsodyScore) {
                return analysisObj.pronunciation.PronunciationAssessment.ProsodyScore;
            }
            if (analysisObj.pronunciation && analysisObj.pronunciation.pronunciationAssessment && analysisObj.pronunciation.pronunciationAssessment.ProsodyScore) {
                return analysisObj.pronunciation.pronunciationAssessment.ProsodyScore;
            }
            if (analysisObj.ProsodyScore) {
                return analysisObj.ProsodyScore;
            }
            return analysisObj.prosodyScore || 0;
        };
        
        const getRecognizedText = (analysisObj) => {
            return analysisObj.RecognizedText || analysisObj.recognizedText || "";
        };
        
        // Make sure we extract the correct file IDs
        // Look in different places as the data structure might vary - prioritize 'key' field over 'session'
        let firstFileId = '';
        if (data.firstReview && data.firstReview.key) {
            firstFileId = data.firstReview.key;
        } else if (data.firstReview && data.firstReview.session) {
            firstFileId = data.firstReview.session;
        } else if (data.firstReview && data.firstReview.fileId) {
            firstFileId = data.firstReview.fileId;
        } else if (data.firstFileId) {
            firstFileId = data.firstFileId;
        } else if (data['First File ID']) {
            firstFileId = data['First File ID'];
        }
        
        let secondFileId = '';
        if (data.secondReview && data.secondReview.key) {
            secondFileId = data.secondReview.key;
        } else if (data.secondReview && data.secondReview.session) {
            secondFileId = data.secondReview.session;
        } else if (data.secondReview && data.secondReview.fileId) {
            secondFileId = data.secondReview.fileId;
        } else if (data.secondFileId) {
            secondFileId = data.secondFileId;
        } else if (data['Second File ID']) {
            secondFileId = data['Second File ID'];
        }
        
        // Extract and format time fields for date parameters
        const extractDate = (reviewObj) => {
            if (!reviewObj || !reviewObj.time) return null;
            
            try {
                if (Array.isArray(reviewObj.time)) {
                    // Time array format: [year, month, day, hour, minute, second, nanoseconds]
                    const [year, month, day] = reviewObj.time;
                    
                    // Format as YYYY-MM-DD (month is already 1-indexed in the array)
                    const formattedMonth = String(month).padStart(2, '0');
                    const formattedDay = String(day).padStart(2, '0');
                    
                    return `${year}-${formattedMonth}-${formattedDay}`;
                } else {
                    // Fallback for non-array time values
                    const date = new Date(reviewObj.time);
                    
                    // Format as YYYY-MM-DD
                    const year = date.getFullYear();
                    const month = String(date.getMonth() + 1).padStart(2, '0');
                    const day = String(date.getDate()).padStart(2, '0');
                    
                    return `${year}-${month}-${day}`;
                }
            } catch (error) {
                console.error('Error extracting date from time field:', error);
                return null;
            }
        };
        
        const firstDate = extractDate(data.firstReview);
        const secondDate = extractDate(data.secondReview);

        // Create the properly formatted data object for the modal
        const selectedReviewData = {
            text: data.text,
            firstAttempt: data['First Attempt'] || data.firstAttempt || data.firstDate,
            firstScore: data['First Score'] || data.firstScore,
            firstDate: firstDate, // Add the extracted date
            
            // Format the firstAnalysis object as expected by ReviewModal and ReviewText
            firstAnalysis: {
                NBest: [
                    {
                        // Extract important fields with uppercase names as expected
                        PronScore: getPronScore(firstAnalysisObj),
                        AccuracyScore: getAccuracyScore(firstAnalysisObj),
                        FluencyScore: getFluencyScore(firstAnalysisObj),
                        CompletenessScore: getCompletenessScore(firstAnalysisObj),
                        ProsodyScore: getProsodyScore(firstAnalysisObj),
                        RecognizedText: getRecognizedText(firstAnalysisObj),
                        
                        // Extract and format Words array with proper casing
                        Words: extractWordsData(firstAnalysisObj)
                    }
                ]
            },
            
            // Use the extracted file ID
            firstFileId: firstFileId,
            secondAttempt: data['Second Attempt'] || data.secondAttempt || data.secondDate,
            secondScore: data['Second Score'] || data.secondScore,
            secondDate: secondDate, // Add the extracted date
            
            // Format the secondAnalysis object as expected by ReviewModal and ReviewText
            secondAnalysis: {
                NBest: [
                    {
                        // Extract important fields with uppercase names as expected
                        PronScore: getPronScore(secondAnalysisObj),
                        AccuracyScore: getAccuracyScore(secondAnalysisObj),
                        FluencyScore: getFluencyScore(secondAnalysisObj),
                        CompletenessScore: getCompletenessScore(secondAnalysisObj),
                        ProsodyScore: getProsodyScore(secondAnalysisObj),
                        RecognizedText: getRecognizedText(secondAnalysisObj),
                        
                        // Extract and format Words array with proper casing
                        Words: extractWordsData(secondAnalysisObj)
                    }
                ]
            },
            
            // Use the extracted file ID
            secondFileId: secondFileId
        };
                
        // Update only the selectedReviewData, not the full reviewData list
        this.setState({ 
            openPhonemesReview: true, 
            selectedReviewData,
            reviewMode 
        });
    }

    closeReviewModal = () => {
        this.setState({ 
            openPhonemesReview: false,
            // We don't need to clear selectedReviewData here
        });
    }

    downloadPhoneme = (data) => {
        getAIAudioFile(this.props.id, data.fileId);
    }
    saveReadingTarget = (newVal) => {
        let studentProfile = this.props.studentProfile;
        studentProfile.readingTime = newVal;
        if (studentProfile.id && studentProfile.id !== 'null') {
            this.props.patchStudentProfile(studentProfile);
        } else {
            this.props.getStudentProfile(this.props.id);
            setTimeout(() => {
                let studentProfile = this.props.studentProfile;
                studentProfile.readingTime = newVal;
                this.props.patchStudentProfile(studentProfile);
            }, 600)
        }
        this.setState({ "readingTimeValue": newVal });
    }
    calculateMinuteTickValue = () => {
        let startMinuteRecord = this.state.fluency && this.state.fluency[0] && this.state.fluency[0].x;
        let endMinuteRecord = this.state.fluency && this.state.fluency[this.state.fluency.length - 1] && this.state.fluency[this.state.fluency.length - 1].x;
        startMinuteRecord = moment(startMinuteRecord);
        endMinuteRecord = moment(endMinuteRecord);
        return endMinuteRecord.diff(startMinuteRecord, 'days')
    }
    calculateAccuracyTickValue = () => {
        let startAccuracyRecord = this.state.accuracy && this.state.accuracy[0] && this.state.accuracy[0].x;
        let endAccuracyRecord = this.state.accuracy && this.state.accuracy[this.state.accuracy.length - 1] && this.state.accuracy[this.state.accuracy.length - 1].x;
        startAccuracyRecord = moment(startAccuracyRecord);
        endAccuracyRecord = moment(endAccuracyRecord);
        return endAccuracyRecord.diff(startAccuracyRecord, 'days');   
    }
    transformReviewData = (reviewData) => {
        if (!reviewData || !Array.isArray(reviewData)) {
            // Handle the case when reviewData is not an array
            // If it's a single object, wrap it in an array
            const dataToProcess = Array.isArray(reviewData) ? reviewData : [reviewData];
            
            const transformed = dataToProcess.map(review => ({
                text: review.text || '',
                'First Attempt': review.firstAttempt || review.firstDate || '',
                'First Score': review.firstScore ? Math.round(review.firstScore) : 0,
                'Second Attempt': review.secondAttempt || review.secondDate || '',
                'Second Score': review.secondScore ? Math.round(review.secondScore) : 0,
                firstReview: review.firstReview || {},
                secondReview: review.secondReview || {},
                // Store the raw date for sorting
                secondDateRaw: review.secondAttempt || review.secondDate || ''
            }));

            // Sort by secondDate in descending order (most recent first)
            return transformed.sort((a, b) => {
                // Debug logging to see the actual date formats
                console.log('Sorting dates - A:', a.secondDateRaw, 'B:', b.secondDateRaw);
                
                // Handle different date formats more robustly
                const parseDate = (dateStr) => {
                    if (!dateStr) return new Date(0); // Return epoch for empty dates
                    
                    // Handle "2025-05-15-04:00" format by replacing last hyphen with T
                    if (dateStr.includes('-') && dateStr.match(/\d{4}-\d{2}-\d{2}-\d{2}:\d{2}/)) {
                        const isoFormat = dateStr.replace(/(\d{4}-\d{2}-\d{2})-(\d{2}:\d{2})/, '$1T$2');
                        return new Date(isoFormat);
                    }
                    
                    // Handle MM/DD/YYYY format
                    if (dateStr.includes('/')) {
                        return new Date(dateStr);
                    }
                    
                    // Try parsing as-is
                    return new Date(dateStr);
                };
                
                const dateA = parseDate(a.secondDateRaw);
                const dateB = parseDate(b.secondDateRaw);
                
                console.log('Parsed dates - A:', dateA, 'B:', dateB);
                
                return dateB - dateA;
            });
        }
        
        // Original function for array data with sorting added
        const transformed = reviewData.map(review => ({
            text: review.text || '',
            'First Attempt': review.firstAttempt || review.firstDate || '',
            'First Score': review.firstScore ? Math.round(review.firstScore) : 0,
            'Second Attempt': review.secondAttempt || review.secondDate || '',
            'Second Score': review.secondScore ? Math.round(review.secondScore) : 0,
            firstReview: review.firstReview || {},
            secondReview: review.secondReview || {},
            // Store the raw date for sorting
            secondDateRaw: review.secondAttempt || review.secondDate || ''
        }));

        // Sort by secondDate in descending order (most recent first)
        return transformed.sort((a, b) => {
            // Debug logging to see the actual date formats
            console.log('Sorting dates - A:', a.secondDateRaw, 'B:', b.secondDateRaw);
            
            // Handle different date formats more robustly
            const parseDate = (dateStr) => {
                if (!dateStr) return new Date(0); // Return epoch for empty dates
                
                // Handle "2025-05-15-04:00" format by replacing last hyphen with T
                if (dateStr.includes('-') && dateStr.match(/\d{4}-\d{2}-\d{2}-\d{2}:\d{2}/)) {
                    const isoFormat = dateStr.replace(/(\d{4}-\d{2}-\d{2})-(\d{2}:\d{2})/, '$1T$2');
                    return new Date(isoFormat);
                }
                
                // Handle MM/DD/YYYY format
                if (dateStr.includes('/')) {
                    return new Date(dateStr);
                }
                
                // Try parsing as-is
                return new Date(dateStr);
            };
            
            const dateA = parseDate(a.secondDateRaw);
            const dateB = parseDate(b.secondDateRaw);
            
            console.log('Parsed dates - A:', dateA, 'B:', dateB);
            
            return dateB - dateA;
        });
    }
    render() {
        const { classes, student, history, studentProfile } = this.props;
        const rows = [
            { id: 'phoneme', label: <FormattedMessage id='BuddyBooks.phoneme' /> },
            { id: 'averageScore', label: <FormattedMessage id='BuddyBooks.averageScore' /> },
        ];

        const rows2 = [
            { id: 'text', label: <FormattedMessage id='BuddyBooks.text' /> },
            { id: 'score', label: <FormattedMessage id='BuddyBooks.score' /> },
            { id: 'date', label: <FormattedMessage id={'BuddyBooks.date'} /> }

        ]

        const rows3 = [
            { id: 'text', label: <FormattedMessage id='BuddyBooks.text' /> },
            { id: 'First Attempt', label: 'First Attempt' },
            { id: 'First Score', label: 'First Score' },
            { id: 'Second Attempt', label: 'Second Attempt' },
            { id: 'Second Score', label: 'Second Score' },
        ];
        const TitleAcc = ({ width, height }) => {
            const style = { fontWeight: 'bold' }

            return (
                <text
                    x="44%" dominantBaseline="middle" textAnchor="middle"
                    y={-15}
                    style={style}
                >
                    Total Accuracy
                </text>
            )
        };
        const Title = ({ width, height }) => {
            // You can console.log(data) to see what other properties are available
            const style = { fontWeight: 'bold' }

            return (
                <text
                    x="36%" dominantBaseline="middle" textAnchor="middle"
                    y={-18}
                    style={style}
                >
                    Last Seven Days Reading Time in Minutes
                </text>
            )
        };


        const tooltip = (slice, label) => {
            const options = { weekday: 'long', month: 'numeric', day: 'numeric' };
            let bookId = "";
            let bookDetail = {};
            if (label === 'Words Per Minute') {
                bookId = slice.slice.points[0].data.bookId;
                bookDetail = (this.props.books && this.props.books.filter(book => book.id == bookId));
                let res = this.state.bookListWPM.filter(book => book.id == bookId);
                bookDetail = bookDetail.length == 0 ? res : bookDetail;
            }
            return (
                <>
                {!isNaN(slice.slice.points[0].data.y) ?
                <div
                    style={{
                        background: 'white',
                        padding: '9px 12px',
                        border: '1px solid #ccc',
                    }}>
                    <div>
                        <strong>{slice.slice.points[0].data.x.toLocaleDateString('en-US', options)}</strong>
                    </div>
                    <div>
                        {
                            label === 'Accuracy'
                                ? <>Accuracy: <strong>{Math.round(slice.slice.points[0].data.y)}%</strong></>
                                :
                                label === 'Words Per Minute' ?
                                    <>
                                        WCPM: <strong>{slice.slice.points[0].data.y >= 200 ? "200+" : Math.round(slice.slice.points[0].data.y.toFixed(0))}</strong>
                                        <br />
                                        Book: <strong>{bookDetail.length > 0 && bookDetail[0].name}</strong> <br />
                                        {/* Render Lexile levels only if the nvp are found in data */}
                                        { bookDetail.length > 0 && (bookDetail[0].gradeLevel || bookDetail[0].gradeLevel === 0 ) && 
                                            <>Grade Level: <strong>{bookDetail[0].gradeLevel === 0 ? 'K' : bookDetail[0].gradeLevel}</strong> <br /></>
                                        }

                                    </> : <>{label}: <strong>{Math.round(slice.slice.points[0].data.y.toFixed(0))}</strong></>
                        }
                    </div>
                </div>: ""}
                </>
            )
        };

        
        const strokeWidth = 7;
        const rotation = 0.625;
        const circleRatio = 0.75;
        const numSeparators = 10;
        const targetValue = this.props.studentProfile ? this.props.studentProfile.readingTime * 60 : 15 * 60;
        let tickpoint = 0;
        const tickValues = [];
        while (tickpoint <= targetValue) {
            tickValues.push(tickpoint);
            tickpoint = tickpoint + 300;
        }
        tickValues.push(tickpoint);
        let specificTickValue = this.state.fluency.length > 8 ? 5 : 'every day';
        let specificTickValueAcc = this.state.accuracy.length > 8 ? 5 : 'every day';
        let diffMinuteRecord = this.calculateMinuteTickValue();
        let diffAccuracyRecord = this.calculateAccuracyTickValue();

        if (diffMinuteRecord >= 14) {
            specificTickValue = 7;
        }
        if (diffAccuracyRecord >= 14) {
            specificTickValueAcc = 7;
        }
        const percentageProgress = this.state.progress && this.state.progress.currentProgress ? Math.floor(this.state.progress.currentProgress * 1000) / 10 : 0;
        const getColors = (chart) => {
            if (chart.id == 'Words Correct Per Minute')
                return "#0087b6";
            else if (chart.id == 'Under50')
                return "rgba(255, 0, 0,0.1)";
            else if (chart.id == 'Under150')
                return "rgba(255, 255, 0,0.3)";
            else
                return 'rgba(0, 255, 0,0.15)'
        }
        let under50Data = {};
        let under150Data = {};
        let under200Data = {};
        let bookChange = [];
        if (this.state.fluency && this.state.fluency.length > 0) {
            let length = this.state.fluency.length;
            let bookChangePoints = [];
            for (let i = 1; i < length; i++) {
                if (this.state.fluency[i].bookId != this.state.fluency[i - 1].bookId) {
                    bookChangePoints.push(
                        {
                            axis: 'x',
                            value: new Date(this.state.fluency[i].x),
                            lineStyle: {
                                stroke: 'black',
                                strokeWidth: 1.5,
                                opacity: 0.8,
                            },
                        })
                }
            }
            under50Data = {
                "id": 'Challenge', color: 'hsl(301, 70%, 50%)',
                "data": [{ x: this.state.fluency[0].x, y: '50' },
                { x: this.state.fluency[length - 1].x, y: '50' }]
            };
            under150Data = {
                "id": 'Instructional', color: 'hsl(1, 83%, 69%)',
                "data": [{ x: this.state.fluency[0].x, y: '150' },
                { x: this.state.fluency[length - 1].x, y: '150' }]
            };
            under200Data = {
                "id": 'Fluent', color: 'green',
                "data": [{ x: this.state.fluency[0].x, y: '200' },
                { x: this.state.fluency[length - 1].x, y: '200' }]
            };
            bookChange.push(...bookChangePoints);
        }
        const dataSourceWPM = this.state.fluency.length > 0 ? [under50Data, under150Data, under200Data,
            { "id": "Words Correct Per Minute", "data": this.state.fluency }]
            : [{ "id": "Words Correct Per Minute", "data": this.state.fluency }];

        if (!this.state.fluency) {
            return null;
        }

        return (
            <div className={classes.container}>
                <div className={classes.title}>
                    {student.firstName ? (
                        <Typography className={classes.text} variant='h3'>
                            {student.firstName && `${student.firstName}'s `} <FormattedMessage id='Dashboard.title' />
                        </Typography>
                    ) : (
                        <Typography className={classes.text} variant='h3'>
                            <FormattedMessage id='Dashboard.title' />
                        </Typography>
                    )}
                </div>


                <div style={{ marginBottom: "20px" }}>

                    <Card aria-label="Last Seven Days Reading Time">
                        <div className={classes.header}>
                            <Typography className={classes.chartTitle} variant='h5'>Reading Time &nbsp; - &nbsp; Last 7 Days</Typography>
                        </div>
                        <CardContent>
                            <div style={{
                                'display': 'flex',
                                'margin': '0 auto',
                                'width': '80%',
                                'padding': '0 16px 0 6px',
                                'boxSizing': 'border-box'
                            }}>
                                <Typography style={{ paddingRight: "10px", minWidth: "fit-content" }}>
                                    <FormattedMessage id='BuddyBooks.ReadingTarget' />: </Typography>
                                <Slider
                                    className='slider'
                                    value={this.state.readingTimeValue}
                                    onChange={(ev, newVal) => this.saveReadingTarget(newVal)}
                                    valueLabelDisplay='auto'
                                    name='curtainOpacity'
                                    defaultValue={this.state.readingTimeValue}
                                    step={5}
                                    min={10}
                                    max={90}
                                    marks={[
                                        { value: 10, label: '10' },
                                        { value: 15, label: '15' },
                                        { value: 20, label: '20' },
                                        { value: 25, label: '25' },
                                        { value: 30, label: '30' },
                                        { value: 35, label: '35' },
                                        { value: 40, label: '40' },
                                        { value: 45, label: '45' },
                                        { value: 50, label: '50' },
                                        { value: 55, label: '55' },
                                        { value: 60, label: '60' },
                                        { value: 65, label: '65' },
                                        { value: 70, label: '70' },
                                        { value: 75, label: '75' },
                                        { value: 80, label: '80' },
                                        { value: 85, label: '85' },
                                        { value: 90, label: '90' },
                                    ]}
                                />
                            </div>
                            <br />
                            <LastSevenDay
                                data={this.state.readingTime}
                                targetReadingTime={studentProfile.readingTime}
                                downloadComplete={this.state.downloadComplete}
                                studentId={this.props.id}
                            />
                        </CardContent>
                        <Divider />
                    </Card>
                </div>
                <div style={{ 
                    width: '100%', 
                    maxWidth: '100%', 
                    overflow: 'hidden', 
                    marginBottom: '20px',
                    boxSizing: 'border-box',
                    padding: '0 8px'
                }} className="dashboard-charts-container-wrapper">
                    <DashboardDataContainer 
                        accuracy={this.state.accuracy}
                        skipRate={this.state.skipRate}
                        fluency={this.state.fluency}
                        loading={{
                            accuracy: !this.state.accuracyLoaded,
                            skipRate: !this.state.skipRateLoaded,
                            fluency: !this.state.fluencyLoaded
                        }}
                        error={null}
                        studentId={this.props.id}
                        student={this.props.student}
                    />
                </div>

                {this.state.reviewData &&
                    <div>
                        <ReviewTable
                            data={Array.isArray(this.state.reviewData) ? 
                                this.transformReviewData(this.state.reviewData) : 
                                this.transformReviewData([this.state.reviewData])}
                            reviewFunc={this.showReviewModal}
                            loader={this.state.reviewDataLoaded ? false : true}
                            title={<FormattedMessage id='BuddyBooks.ReviewTitle' />}
                            rowsPerPage={[5, 10, 15]}
                        />
                    </div>
                }
                <Dialog open={this.state.openPhonemesReview} fullWidth={true} maxWidth='xl'>
                    <Paper className={classes.list}>
                        <PhonemesReview
                            data={this.state.selectedReviewData}
                            title={this.state.reviewMode ? 'Review Mode' : `Phonemes (${this.state.phoneme}): Review`}
                            studentId={this.props.id}
                            exitReview={this.closeReviewModal}
                        />
                    </Paper>
                </Dialog>
            </div>
        );
    }

}

const mapState = ({ platform: { skills, studentProfile, student, books } }) => {
    return {
        skills,
        student,
        studentProfile,
        books
    }
};

const mapDispatch = (dispatch) => {
    return {
        getStudent: (id) => dispatch(getStudent(id)),
        getStudentProfile: (id) => dispatch(getStudentProfile(id)),
        patchStudentProfile: (studentProfile) => dispatch(patchStudentProfile(studentProfile)),
        createStudentProfile: (studentProfile) => dispatch(createStudentProfile(studentProfile)),
        getBooksForStudent: (studentId) => dispatch(getBooksForStudent(studentId)),
    }
};
export default connect(mapState, mapDispatch)(withStyles(baseStyle)(BuddyBooksData));